
import Vue from 'vue';
import URI from 'urijs';
import $ from 'jquery';

import {saveAs} from 'file-saver';

import * as RootStore from '@/store/search/';
import * as HistoryStore from '@/store/search/history';
import * as FilterStore from '@/store/search/form/filters';

import UrlStateParser from '@/store/search/util/url-state-parser';

import Modal from '@/components/Modal.vue';

import uid from '@/mixins/uid';

export default Vue.extend({
	components: {
		Modal,
	},
	data: () => ({
		sessionStart: new Date().getTime(),
		shownOlderEntries: 0,
		sharingUrl: null as null|string,
		importUrlError: null as null|string,
		importUrlVisible: false,
		clearHistoryVisible: false,
		uid: uid()
	}),
	computed: {
		history(): HistoryStore.ModuleRootState { return HistoryStore.getState() },
		recentHistory(): HistoryStore.ModuleRootState {
			let olderEntryCount = 0;
			return this.history.filter((e: HistoryStore.FullHistoryEntry, i) => (e.timestamp >= this.sessionStart) || (olderEntryCount++) < this.shownOlderEntries || i < 2);
		},
		isSharingUrl(): boolean { return this.sharingUrl != null; },
	},

	methods: {
		remove(index: number): void { HistoryStore.actions.removeEntry(index); },
		openShareUrl(entry: HistoryStore.FullHistoryEntry) { this.sharingUrl = entry.url; },
		closeShareUrl() { this.sharingUrl = null; },

		downloadAsFile(entry: HistoryStore.FullHistoryEntry) {
			const {file, fileName} = HistoryStore.get.asFile(entry);
			saveAs(file, fileName);
		},

		load(entry: HistoryStore.HistoryEntry) {
			// @ts-ignore
			$(this.$refs.modal).modal('toggle');
			RootStore.actions.replace(entry);
		},

		async importFromUrl() {
			const input = (this.$refs.importUrlInput as HTMLInputElement);
			const importUrl = input.value;
			if (!importUrl) {
				this.importUrlError = null;
				this.importUrlVisible = false;
			}
			if (!input.checkValidity()) {
				this.importUrlError = 'Invalid url';
				return;
			}

			const uri = new URI(importUrl);
			const state = await new UrlStateParser(FilterStore.getState().filters, uri).get();
			HistoryStore.actions.addEntry({
				entry: state,
				pattern: (uri.query(true) as any).patt,
				url: importUrl,
			});

			this.importUrlError = null;
			this.importUrlVisible = false;
		},
		clearHistory() {
			HistoryStore.actions.clear();
			this.clearHistoryVisible = false;
		}
	},
	watch: {
		isSharingUrl(value: boolean) {
			if (value) {
				Vue.nextTick(() => {
					const input = (this.$refs.shareUrlInput as HTMLInputElement);
					input.focus();
					input.setSelectionRange(0, input.value.length);
				});
			}
		}
	}
});
